import ItemInfos from '@/src/interfaces/catalog/item-infos'
import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import { useLongPress } from '@/src/hooks/useLongPress'
import SvgMinus from '@/src/assets/svgs/collection/minus.svg'
import SvgPlus from '@/src/assets/svgs/collection/plus.svg'
import { AnswerType } from '@/src/hooks/product/useWizard'
import { useMerchant } from '@/src/context/merchant/merchant-context'

interface Props {
    itemOption: ItemInfos.ItemOption
    itemGroup: ItemInfos.ItemGroup
    answerType: AnswerType
    quantity: number
    sumOfQtyAnswered: number
    isSelected: boolean
    setBottomSheet(e: boolean): void
    handleUpdateQuantity(value: number): void
}

export default function AnswerTypeComponent(props: Props) {
    const { localMode } = useMerchant()

    const itemGroup = props.itemGroup
    const itemOption = props.itemOption
    const quantity = props.quantity
    const answerType = props.answerType

    const unlimited = itemOption.maxQty === 0 && itemOption.minQty === 0

    const increaseRef = useRef<HTMLDivElement>(null)
    const decreaseRef = useRef<HTMLDivElement>(null)

    const disablePlusIcon = () => {
        if (itemOption.maxQty === quantity && !unlimited)
            return true

        if (props.sumOfQtyAnswered >= itemGroup.maxQtyItems)
            return true

        return false
    }

    const longPress = useLongPress({
        onLongPress: () => props.setBottomSheet(true),
        delay: 500
    })

    useEffect(() => {
        if (answerType === 'add') {
            const cleanupIncrease = longPress.attachListeners(increaseRef.current)
            const cleanupDecrease = longPress.attachListeners(decreaseRef.current)

            return () => {
                cleanupIncrease?.()
                cleanupDecrease?.()
            }
        }
    }, [answerType, quantity])

    if (localMode)
        return <></>

    if (props.answerType === 'checkbox')
        return <div className={`${props.isSelected ? styles.checkedSquareAnswer : styles.checkSquareAnswer}`} />

    if (props.answerType === 'radio')
        return <div className={props.isSelected ? styles.checkedAnswer : styles.checkAnswer} />

    return (
        <div className={`${styles.renderQuantityOptions} ${quantity > 0 ? styles.addBorder : ''}`}>
            {
                quantity > 0 &&
                <>
                    <div
                        ref={decreaseRef}
                        className={styles.minus}
                        onClick={() => props.handleUpdateQuantity(quantity - 1)}
                    >
                        <SvgMinus className={styles.svgMinus} />
                    </div>
                    <span className={styles.quantity}>
                        {quantity}
                    </span>
                </>
            }
            <div
                ref={increaseRef}
                className={`${styles.plus} ${disablePlusIcon() ? styles.disablePlus : ''}`}
                onClick={() => props.handleUpdateQuantity(quantity + 1)}
            >
                <SvgPlus className={styles.svgPlus} />
            </div>
        </div>
    )
}
